import { render, staticRenderFns } from "./InvoiceFolderTags.vue?vue&type=template&id=30a7aa2b&scoped=true&"
import script from "./InvoiceFolderTags.vue?vue&type=script&lang=js&"
export * from "./InvoiceFolderTags.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceFolderTags.vue?vue&type=style&index=0&id=30a7aa2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a7aa2b",
  null
  
)

export default component.exports